import { Section } from '@/components/Section';
import { ProgramImageTile } from '@/components/ProgramImageTile';
import { PROGRAMS } from '@/lib/content';

export function ProgramsPage() {
  const programs = PROGRAMS;

  return (
    <Section eyebrow="What we teach" title="Programs.">
      <div className="grid gap-6 md:grid-cols-2">
        {programs.map((p) => {
          return (
            <article
              key={p.slug}
              className="overflow-hidden rounded-lg border border-bone/10 bg-neutral-900/40"
            >
              <ProgramImageTile slug={p.slug} title={p.title} aspectClassName="aspect-[16/10]" />
              <div className="p-6">
                <div className="font-display text-3xl">{p.title}</div>
                <p className="mt-3 text-bone/70">{p.blurb}</p>
                <ul className="mt-4 list-inside list-disc space-y-1 text-sm text-bone/60">
                  {p.bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
              </div>
            </article>
          );
        })}
      </div>
    </Section>
  );
}
